import styles from './styles.scss';
import { Button } from 'components/Button';
import { useToggle } from 'hooks';
import SalesPolicyModal from 'views/CheckoutPage/PolicyInformation/salesPolicyModal';
import { CheckoutModal } from 'views/CheckoutPage/checkoutModal';
import { rm } from 'utils';

export const Terms = () => {
  const [modalOpen, toggleModal] = useToggle(false);

  return (
    <div className={styles.terms}>
      {rm('checkout_accept_terms')}
      &nbsp;
      <Button type="button" onClick={toggleModal} appearance="link" className={styles.termsButton}>
        {rm('checkout_our_terms').toLowerCase()}
      </Button>
      <CheckoutModal onClose={toggleModal} show={modalOpen} contentClassName={styles.modal}>
        <SalesPolicyModal onClose={toggleModal} />
      </CheckoutModal>
    </div>
  );
};
